import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import minicartQuery from '~/graphql/cart/minicart.gql';
import createNewCartMutation from '~/graphql/cart/createNewCart.gql';
import addProductsToCartMutation from '~/graphql/cart/addProductsToCart.gql';
import updateCartMutation from '~/graphql/cart/updateCart.gql';

var token = function token() {
  return window.localStorage.MDM_AUTH_TOKEN;
};

function fetchCart(_x, _x2) {
  return _fetchCart.apply(this, arguments);
}

function _fetchCart() {
  _fetchCart = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(context, payload) {
    var locale, _ref, data;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            locale = context.state.i18n.currentLocale.iso;
            _context.next = 3;
            return context.app.apolloProvider.defaultClient.query({
              query: minicartQuery,
              variables: {
                locale: locale,
                token: token(),
                cartId: payload
              }
            });

          case 3:
            _ref = _context.sent;
            data = _ref.data;
            return _context.abrupt("return", data);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchCart.apply(this, arguments);
}

function createCart(_x3) {
  return _createCart.apply(this, arguments);
}

function _createCart() {
  _createCart = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(context) {
    var locale, _ref2, data;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            locale = context.state.i18n.currentLocale.iso;
            _context2.next = 3;
            return context.app.apolloProvider.defaultClient.mutate({
              mutation: createNewCartMutation,
              variables: {
                locale: locale,
                token: token()
              }
            });

          case 3:
            _ref2 = _context2.sent;
            data = _ref2.data;
            return _context2.abrupt("return", data);

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _createCart.apply(this, arguments);
}

function addCart(_x4, _x5) {
  return _addCart.apply(this, arguments);
} // async function addCartCustomizable(context, payload) {
//   const locale = context.state.i18n.currentLocale;
//   const xhrUri = `${context.state.sharedEnv.payload.web}${locale.market}/${locale.language}/custom/panier/${payload}`;
//   const { data } = await context.$axios.get(xhrUri, {
//     'axios-retry': {
//       retries: 0,
//     },
//   });
//   return data;
// }


function _addCart() {
  _addCart = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee3(context, payload) {
    var locale, _ref3, data;

    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            locale = context.state.i18n.currentLocale.iso;
            _context3.next = 3;
            return context.app.apolloProvider.defaultClient.mutate({
              mutation: addProductsToCartMutation,
              variables: {
                locale: locale,
                token: token(),
                cartId: payload.token,
                products: [{
                  reference: payload.reference,
                  quantity: payload.quantity
                }]
              }
            });

          case 3:
            _ref3 = _context3.sent;
            data = _ref3.data;
            return _context3.abrupt("return", data);

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _addCart.apply(this, arguments);
}

function updateCart(_x6, _x7) {
  return _updateCart.apply(this, arguments);
}

function _updateCart() {
  _updateCart = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee4(context, payload) {
    var locale, _ref4, data;

    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            locale = context.state.i18n.currentLocale.iso;
            _context4.next = 3;
            return context.app.apolloProvider.defaultClient.mutate({
              mutation: updateCartMutation,
              variables: {
                locale: locale,
                token: token(),
                cartId: payload.token,
                items: [{
                  id: payload.id,
                  quantity: payload.quantity
                }]
              }
            });

          case 3:
            _ref4 = _context4.sent;
            data = _ref4.data;
            return _context4.abrupt("return", data);

          case 6:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _updateCart.apply(this, arguments);
}

export { fetchCart, createCart, addCart, updateCart };